import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../hooks/hooks";
import Table from "../../../../../common/components/table-manager/v1.1/table";
import { routes } from "../../../../../redux/route-management/routes/action";
import { selectRoutesListItems } from "../../../../../redux/route-management/routes/selector";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../components/PageLoader";

const ManagementRoutes = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const itemsData = useSelector(selectRoutesListItems)
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'MobilityRouteNumber', headerName: 'MobilityRouteNumber', sortable: true, filter: true },
      { field: 'MobilityRouteName', headerName: 'MobilityRouteName' },
    ]);
  }
  const handleAdd = () => {
    navigate(`${0}`)
  }
  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }
  const handleReloadData = () => {
    fetchRoutes()
      }
 const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "MobilityRouteName",
        FieldText: "MobilityRouteName",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]}
    }
  const handleDelete = (data: any) => {
    dispatch(routes.delete({
      url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/route-management/routes/delete`,
      entity: 'routes',
      jsonData: {
        Records: [
          {
            Id: data.Id
          }
        ]
      }
    })).then(() => {
      dispatch(routes.list({
        url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/route-management/routes/list`,
        entity: 'routes',
        jsonData: {}
      }));
    });
  }
  const additionButtons: any = [
        {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
        <title>Add</title>
        <path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
        callback: () => handleAdd(),
        },
        {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    }
  ];
  const fetchRoutes = () => {
    dispatch(routes.list({
      url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/route-management/routes/list`, entity: 'routes', jsonData: {

        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",

      }
    }))
  }
  useEffect(() => {
    createColumnDefs()
    fetchRoutes()
  }, [pageData, pageSize])
  return (
    <>
      {itemsData?.isLoading ? <PageLoader />
        :
        <Table
          columnData={columnDefs}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          enableFilter={true}
          onSearch={handleSearch}
          setPageSize={setPageSize}
          rowData={itemsData?.result?.items}
          setPageData={setPageData}
          paginationData={itemsData?.result?.pagination}
          onEdit={handleEdit}
          additionButtons={additionButtons}
          onDelete={handleDelete}
          headingName="Routes" />
      }</>

  );
};

export default ManagementRoutes;


